<template>
<div class="info">
	<div class="title">发票信息：
	    {{info.invoiceType=='1'||!info.invoiceType?'不开发票':(info.invoiceType=='2'?'专票（纸质）':'普票（电子）')}}
	</div>
	<Form :label-width="150" class="mt15" v-if="info.invoiceType&&info.invoiceType!='1'">
	    <FormItem label="公司名称：" class="w600">
	        {{info.invoiceName}}
	    </FormItem>
	    <FormItem label="统一社会信用代码：" class="w600">
	        {{info.invoiceFaxNo}}
	    </FormItem>
	    <FormItem label="开户地址：" class="w600">
	        {{info.invoiceAddress}}
	    </FormItem>
	    <FormItem label="联系电话：" class="w600">
	        {{info.invoicePhone}}
	    </FormItem>
	    <FormItem label="开户行：" class="w600">
	        {{info.invoiceBank}}
	    </FormItem>
	    <FormItem label="对公账号：" class="w600">
	        {{info.invoiceAccount}}
	    </FormItem>
	    <FormItem label="电子邮箱：" class="w600">
	        {{info.email}}
	    </FormItem>
	    <FormItem label="邮寄地址：" class="w600">
	        {{info.postAddress}}
	    </FormItem>
	</Form>
</div>
</template>
<script>
export default {
	props:{
		info:Object,
	},
}
</script>
<style scoped>
	span.red{
		font-size: 14px;
		margin-left: 15px;
		color:red;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployer/common/InvoiceInfo.vue